module.exports = __webpack_public_path__ + "static/StJude-21aa96dae55cdbc5df3e1fdcce2b5da2.png";